import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BookmarkCallout from './bookmark-callout';

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${props => ((props.theme.isMobile || props.smallText) ? 0 : 5)}px;

  & > .callout {
    display: inline;

    .callout-inner {
      transform: translateY(0) translateX(-16px) !important;

      .callout-indicator {
        display: none;
      }
    }

    button {
      margin-top: 0;
      z-index: 1;
      right: 0;
      > .icon-lw {
        font-size: 18px;
      }
    }
  }

  & > span {
    width: 90%;
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: ${props => (props.smallText ? 0 : 18)}px;

    > a {
      color: ${props => props.theme.bodyColor};
      font-family: ${props => props.theme.fontFamilyHeader};
      font-weight: ${props => props.theme.fontWeightBold};
      ${props => (props.theme.isMobile ? `
        font-size: 18px;
        line-height: 130%;
      ` : `
        font-size: 24px;
        line-height: 31px;
      `)};

      ${props => (props.smallText && `
        display: inline-block;
        line-height: 0px;
        > span {
          font-family: ${props.theme.fontFamilyBody};
          font-weight: ${props.theme.fontWeightHeavy};
          font-size: 14px;
          line-height: 17px;
          text-transform: uppercase;
          height: 32px;
          vertical-align: middle;
        }
      `)}

      ${props => (!props.smallText && `
        &:hover {
          text-decoration: none;
        }
      `)}
    }
  }
`;

export default function WireTitle({ wire }) {
  const calloutWire = {
    wire_id: wire.id,
  };

  return (
    <Header>
      <span>
        <a href={`/wires/${wire.slug}`} data-event-type="click" data-event="link_click">
          {wire.title}
        </a>
      </span>
      <BookmarkCallout wire={calloutWire} rightAligned={false} />
    </Header>
  );
}

WireTitle.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    profile: PropTypes.shape({
      profilePictureUrl: PropTypes.string,
    }),
  }).isRequired,
};
